export function buildLegacyDashboardRedirect(orgSlug = "", location = {}) {
  return `/platform/o/${orgSlug}/dashboard${location.search || ""}${location.hash || ""}`;
}
